import { lazyLoad } from 'utils/loadable';

export const SendEmailToUsersPage = lazyLoad(
  () => import('./index'),
  module => module.SendEmailToUsers,
);
